<template>
  <MaterialCard>
    <v-data-table
      :headers="headers"
      :items="records"
      hide-actions
      disable-initial-sort
    >
      <template
        slot="items"
        slot-scope="{ item }"
      >
        <td>{{ asTimestamp(item.timestamp) }}</td>
        <td>{{ item.data[0] }}</td>
        <td>{{ item.data[1] }}</td>
        <td>{{ item.data[2] }}</td>
        <td>{{ item.data[3] }}</td>
        <td>{{ item.meta.voltage }}</td>
        <td>{{ item.meta.rssi }}</td>
        <td>
          {{ item.meta.lng }} / {{ item.meta.lat }}
        </td>
      </template>
    </v-data-table>
  </MaterialCard>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    records: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    headers: [
      { sortable: true, text: '時刻', value: 'timestamp' },
      { sortable: false, text: 'データ1' },
      { sortable: false, text: 'データ2' },
      { sortable: false, text: 'データ3' },
      { sortable: false, text: 'データ4' },
      { sortable: false, text: '電圧' },
      { sortable: false, text: 'RSSI' },
      { sortable: false, text: '緯度/経度' }
    ]
  }),
  methods: {
    asTimestamp (time) {
      return moment(new Date(time * 1000)).format('YYYY/MM/DD HH:mm:ss')
    }
  }
}
</script>
